export const BRIDGE_API_NAME_SPACE = 'FabricWebViewJavascriptBridge';
export const BRIDGE_READY_EVENT_NAME = 'FabricWebViewJavascriptBridgeReady';
